var categoriesArray = document.querySelectorAll('.product-card--category');
var categoryCardsArray = document.querySelectorAll(
    '.woocommerce-loop-category__title'
);
var orderby = document.querySelectorAll('.orderby');

// categoriesArray.forEach(cat => {
//   if (cat.children.length > 1) {
//     let newCat = cat.children[cat.children.length - 1];
//     cat.replaceChildren(newCat);
//   } else {
//     null;
//   }
// });

categoryCardsArray.forEach(cat => {
    cat.childNodes.forEach(node =>
        node.nodeName === 'MARK' ? node.remove() : null
    );
});

orderby[0] ? (orderby[0].children[0].innerText = 'Sort by') : null;